export function stickyElements() {
    let stickyEl = $(".sticky-element");
    let margin = +(stickyEl.css("margin-bottom").replace(/[^0-9]/g, ""));
    let parent = stickyEl.closest(".sticky-parent");
    let flag = parent.hasClass("indent");

    function setSticky() {

        let itemHeight = stickyEl.innerHeight() + margin;
        let parentHeight = parent.innerHeight();


        if(parentHeight > itemHeight) {
            parent.css("min-height", itemHeight);

            let parentOffsetLeft = parent.offset().left;
            let parentWidth = parent.innerWidth();

            let headerFix = $(".header").height() + (flag ? 0 : 10);

            let scroll = $(window).scrollTop();

            let startPoint = parent.offset().top - headerFix;
            let endPoint = (parent.offset().top + parentHeight) - (stickyEl.innerHeight() + headerFix);

            if (scroll < startPoint) {
                stickyEl.removeClass("fixed bottom").attr("style", "");
                parent.attr("style", "");

            } else if (scroll >= startPoint && scroll < endPoint) {
                
                if(flag) {
                    parent.css("padding-top", itemHeight);
                }

                stickyEl.addClass("fixed").css({
                    left: parentOffsetLeft,
                    width: parentWidth,
                    top: headerFix
                });

                stickyEl.removeClass("bottom");

            } else {
                stickyEl.addClass("bottom").attr("style", "");
            }
        } else {
            stickyEl.removeClass("fixed bottom").attr("style", "");
            parent.attr("style", "");
        }
    }

    $(window).on("load scroll resize", function() {
        margin = +(stickyEl.css("margin-bottom").replace(/[^0-9]/g, "")) > 0 ? +(stickyEl.css("margin-bottom").replace(/[^0-9]/g, "")) : margin;
        setSticky();
    });


}




// WEBPACK FOOTER //
// ./assets/js/modules/sticky-elements.js